import React from 'react';
import './Home.css';

function Home() {
  return (
    <div className="home-container">
      <div className="home-stage">
        <img src="/images/tattoo_city_19.jpeg" alt="Tattoo City" className="home-image" />
        <a
          href="https://zoepeteford.bandcamp.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="side-label side-label--top"
        >
          NEW ALBUM
        </a>
        <a
          href="https://zoepeteford.bandcamp.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="side-label side-label--bottom"
        >
          OUT ON BANDCAMP 9/22/26
        </a>
      </div>
    </div>
  );
}

export default Home;
